
import { Articolo } from '../models/articolo';
import { Commessa } from '../models/commessa';

export class Lavorazionearticolo {
    Id: number;
    Lavorazioneid: number;
    Articoloid: number;
    Operaioid: number;
    Quantita: number;
    Unitamisura: string;
    Costo: number;
    Iva: number;
    Prezzo: number;
    Note: string;
    Articolo: Articolo;
    Prezzototale: number;

  constructor(){
    this.Id=0;
    this.Lavorazioneid=0;
    this.Articoloid=0;
    this.Operaioid=0;
    this.Quantita=0;
    this.Unitamisura='';
    this.Costo=0;
    this.Iva=0;
    this.Prezzo=0;
    this.Note='';
    this.Articolo=new Articolo();
    this.Prezzototale=0;
  }
}
